import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared.module';

interface Service {
  icon: string;
  title: string;
  description: string;
  link?: string;
  isExternal?: boolean;
}

@Component({
  selector: 'app-reception',
  templateUrl: './reception.component.html',
  styleUrls: ['./reception.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MaterialModule, SharedModule]
})
export class ReceptionComponent implements OnInit, AfterViewInit {

  services: Service[] = [
    {
      icon: 'school',
      title: 'K-12 STEM Education',
      description: 'Interactive learning apps with intuitive design, so students focus on learning. Available on web, iOS, Android, and Amazon.',
      link: '/courses',
      isExternal: false
    },
    {
      icon: 'functions',
      title: 'SAT Math Prep',
      description: 'Comprehensive SAT Math course with practice tests. Study anywhere on your mobile device or tablet.',
      link: 'https://mathwithmeenu.com',
      isExternal: true
    },
    {
      icon: 'psychology',
      title: 'Math With Meenu',
      description: 'Live online math tutoring with expert instructors. Personalized learning paths for every student.',
      link: 'https://mathwithmeenu.com',
      isExternal: true
    },
    {
      icon: 'badge',
      title: 'Employee Onboarding',
      description: 'AI-powered onboarding that makes training stress-free and completely automated across web and mobile.',
      link: '/training',
      isExternal: false
    },
    {
      icon: 'medical_services',
      title: 'Medical Image Management',
      description: 'Enterprise-grade security with end-to-end encryption and powerful search capabilities.',
      link: '/contact-us',
      isExternal: false
    },
    {
      icon: 'build',
      title: 'Custom Software',
      description: 'Turn-key mobile and web solutions built from our library of battle-tested components.',
      link: '/contact-us',
      isExternal: false
    }
  ];

  visibleCards: boolean[] = [];

  constructor(
    private elementRef: ElementRef,
    private router: Router
  ) {
    this.visibleCards = new Array(this.services.length).fill(false);
  }

  onServiceClick(service: Service): void {
    if (!service.link) return;
    if (service.isExternal) {
      window.open(service.link, '_blank', 'noopener,noreferrer');
    } else {
      this.router.navigateByUrl(service.link);
    }
  }

  goToMwm(): void {
    window.open('https://mathwithmeenu.com', '_blank', 'noopener,noreferrer');
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.setupScrollAnimations();
  }

  private setupScrollAnimations(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.getAttribute('data-index') || '0', 10);
            setTimeout(() => {
              this.visibleCards[index] = true;
            }, index * 100);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    // Observe each service card
    setTimeout(() => {
      const cards = this.elementRef.nativeElement.querySelectorAll('.service-card');
      cards.forEach((card: Element, index: number) => {
        card.setAttribute('data-index', index.toString());
        observer.observe(card);
      });
    }, 100);
  }
}
